export const Zoombar = {
  // if: (el, s) => el.getUserSettings('allowZoombar'),
  extends: 'Navbar',
  gap: 'A',
  padding: 'V Z',
  round: 'C1',
  userSelect: 'none',
  ZoomInNavbar: {},
  Box: {
    width: 'A1',
    height: 'A1',
    aspectRatio: '1 / 1',
    round: '100%',
    overflow: 'hidden',
    flexShrink: '0',
    background: '#A3ADB6',
    onInit: (el, s) => {
      const globalTheme = el.call('getGlobalTheme')
      const colorFromCookie = el.call(
        'getCookie',
        `canvas_${globalTheme}_background`
      )
      const initValue =
        colorFromCookie ||
        {
          dark: '#A3ADB6',
          light: '#bac1c9'
        }[globalTheme || 'dark']
      el.setNodeStyles({ background: initValue })
      el.value = initValue
    },
    onDblclick: (ev, el, s) => {
      const globalTheme = el.call('getGlobalTheme')
      const value = {
        dark: '#A3ADB6',
        light: '#bac1c9'
      }[globalTheme]
      el.Input.node.value = value
      el.setNodeStyles({
        background: value
      })
      const gs = window.__canvasGlobalScope
      if (gs?.canvasElement) {
        gs.canvasElement.setNodeStyles({ background: value })
      }
      el.call('removeCookie', `canvas_${globalTheme}_background`)
    },
    Input: {
      opacity: 0,
      value: (el) => el.parent.value,
      border: '0',
      width: 'none',
      minWidth: 'none',
      textAlign: 'start',
      padding: '0',
      type: 'color',
      theme: null,
      onInput: (ev, el, s) => {
        const value = el.node.value || '#A3ADB6'
        const globalTheme = el.call('getGlobalTheme')
        el.parent.setNodeStyles({
          background: value
        })
        const gs = window.__canvasGlobalScope || el.context?.globalScope
        if (gs?.canvasElement) {
          gs.canvasElement.setNodeStyles({ background: value })
        }
        el.call('setCookie', `canvas_${globalTheme}_background`, value)
      }
    }
  },
  NavbarButtonSet: {
    padding: '0',
    Settings: {
      icon: 'sf settings',
      onClick: (ev, el) => {
        el.call('openModal', '/settings', {
          key: '/settings'
        })
      },
      title: 'Settings'
    },
    Keyboard: {
      title: 'Keyboard shortcuts (⌘/)',
      attr: { 'aria-label': 'Keyboard shortcuts' },
      icon: 'sf keyboard',
      onClick: (ev, el) => el.call('openKeyboardShortcuts')
    },
    Question: {
      title: 'Docs',
      icon: 'sf question',
      onClick: (ev, el, s) => {
        el.call('setWindow', 'explorer', 'onboarding')
      }
    }
    // Chat: {
    //   title: 'Support',
    //   icon: 'support',
    //   onClick: (ev, el, s) => {
    //     el.call('loadIntercom')
    //   }
    // }
  },
  NavbarTooltip: {
    top: '-65%',
    tooltipPosition: 'top',
    shapeDirection: 'bottom'
  }
}
